const Checkboxes = ({ id, label, register }) => (
	<div className="checkbox-container">
		<input type="checkbox" name={id} id={id} {...register(id)} />
		<label htmlFor={id}>{label}</label>
	</div>
);

export default Checkboxes;
